import type { WidgetConfiguration } from '@sg-widgets/shared-core';
import { type ContextType, createContext } from 'react';

export interface WidgetConfigurationProps {
  widgetConfiguration: WidgetConfiguration;
}

export const WidgetConfigurationContext = createContext<WidgetConfigurationProps | undefined>(undefined);

export type IWidgetConfigurationContext = ContextType<typeof WidgetConfigurationContext>;
